// constants
import {
    GENERATE_CHARGEBACK_REPORT_ERROR,
    GENERATE_CHARGEBACK_REPORT_REQUEST,
    GENERATE_CHARGEBACK_REPORT_SUCCESS,
    GET_ACTIVE_CHARGEBACK_REPORT_ERROR,
    GET_ACTIVE_CHARGEBACK_REPORT_REQUEST,
    GET_ACTIVE_CHARGEBACK_REPORT_SUCCESS,
    DOWNLOAD_CHARGEBACK_REPORT_ERROR,
    DOWNLOAD_CHARGEBACK_REPORT_REQUEST,
    DOWNLOAD_CHARGEBACK_REPORT_SUCCESS,
    FETCH_CHARGEBACK_DATA_REQUEST,
    FETCH_CHARGEBACK_DATA_SUCCESS,
    FETCH_CHARGEBACK_DATA_FAILURE,
    FETCH_CHARGEBACK_DETAILS_REQUEST,
    FETCH_CHARGEBACK_DETAILS_SUCCESS,
    FETCH_CHARGEBACK_DETAILS_FAILURE,
    VALIDATE_CHARGEBACK_REQUEST,
    VALIDATE_CHARGEBACK_SUCCESS,
    VALIDATE_CHARGEBACK_FAILURE,
    RAISE_CHARGEBACK_REQUEST,
    RAISE_CHARGEBACK_SUCCESS,
    RAISE_CHARGEBACK_FAILURE,
    CHARGEBACK_AGENT_ACTION_REQUEST,
    CHARGEBACK_AGENT_ACTION_SUCCESS,
    CHARGEBACK_AGENT_ACTION_FAILURE,
    CHARGEBACK_MERCHANT_ACTION_REQUEST,
    CHARGEBACK_MERCHANT_ACTION_SUCCESS,
    CHARGEBACK_MERCHANT_ACTION_FAILURE,
    RESET_FIND_TRANSACTION_FORM,
    RESET_RAISE_CHARGEBACK_FORM,
    REFUND_DISPUTE_REQUEST,
    REFUND_DISPUTE_SUCCESS,
    REFUND_DISPUTE_FAILURE,
    CHECK_DISPUTE_STATUS_REQUEST,
    CHECK_DISPUTE_STATUS_SUCCESS,
    CHECK_DISPUTE_STATUS_FAILURE,
} from './chargeback.constants';

export const fetchChargeBackDataRequest = data => ({
    type: FETCH_CHARGEBACK_DATA_REQUEST,
    payload: data,
});
export const fetchChargeBackDataSuccess = data => ({
    type: FETCH_CHARGEBACK_DATA_SUCCESS,
    payload: data,
});
export const fetchChargeBackDataFailure = error => ({
    type: FETCH_CHARGEBACK_DATA_FAILURE,
    payload: error,
});

export const fetchDisputeStatusRequest = data => ({
    type: CHECK_DISPUTE_STATUS_REQUEST,
    payload: data,
});
export const fetchDisputeStatusSuccess = data => ({
    type: CHECK_DISPUTE_STATUS_SUCCESS,
    payload: data,
});
export const fetchDisputeStatusFailure = error => ({
    type: CHECK_DISPUTE_STATUS_FAILURE,
    payload: error,
});

export const fetchChargeBackDetailsRequest = data => ({
    type: FETCH_CHARGEBACK_DETAILS_REQUEST,
    payload: data,
});
export const fetchChargeBackDetailsSuccess = data => ({
    type: FETCH_CHARGEBACK_DETAILS_SUCCESS,
    payload: data,
});
export const fetchChargeBackDetailsFailure = error => ({
    type: FETCH_CHARGEBACK_DETAILS_FAILURE,
    payload: error,
});

export const validateChargeBackRequest = data => ({
    type: VALIDATE_CHARGEBACK_REQUEST,
    payload: data,
});
export const validateChargeBackSuccess = data => ({
    type: VALIDATE_CHARGEBACK_SUCCESS,
    payload: data,
});
export const validateChargeBackFailure = error => ({
    type: VALIDATE_CHARGEBACK_FAILURE,
    payload: error,
});

export const raiseChargeBackRequest = data => ({
    type: RAISE_CHARGEBACK_REQUEST,
    payload: data,
});
export const raiseChargeBackSuccess = data => ({
    type: RAISE_CHARGEBACK_SUCCESS,
    payload: data,
});
export const raiseChargeBackFailure = error => ({
    type: RAISE_CHARGEBACK_FAILURE,
    payload: error,
});

export const chargeBackAgentActionRequest = data => ({
    type: CHARGEBACK_AGENT_ACTION_REQUEST,
    payload: data,
});
export const chargeBackAgentActionSuccess = data => ({
    type: CHARGEBACK_AGENT_ACTION_SUCCESS,
    payload: data,
});
export const chargeBackAgentActionFailure = error => ({
    type: CHARGEBACK_AGENT_ACTION_FAILURE,
    payload: error,
});

export const chargeBackMerchantActionRequest = data => ({
    type: CHARGEBACK_MERCHANT_ACTION_REQUEST,
    payload: data,
});
export const chargeBackMerchantActionSuccess = data => ({
    type: CHARGEBACK_MERCHANT_ACTION_SUCCESS,
    payload: data,
});
export const chargeBackMerchantActionFailure = error => ({
    type: CHARGEBACK_MERCHANT_ACTION_FAILURE,
    payload: error,
});

// REPORTING Actions
export const downloadChargebackReportRequest = payload => ({
    type: DOWNLOAD_CHARGEBACK_REPORT_REQUEST,
    payload,
});

export const downloadChargebackReportSuccess = payload => ({
    type: DOWNLOAD_CHARGEBACK_REPORT_SUCCESS,
    payload,
});

export const downloadChargebackReportError = payload => ({
    type: DOWNLOAD_CHARGEBACK_REPORT_ERROR,
    payload,
});

export const generateChargebackReportRequest = payload => ({
    type: GENERATE_CHARGEBACK_REPORT_REQUEST,
    payload,
});

export const generateChargebackReportSuccess = payload => ({
    type: GENERATE_CHARGEBACK_REPORT_SUCCESS,
    payload,
});

export const generateChargebackReportError = payload => ({
    type: GENERATE_CHARGEBACK_REPORT_ERROR,
    payload,
});

export const getActiveChargebackReportRequest = hideLoader => ({
    type: GET_ACTIVE_CHARGEBACK_REPORT_REQUEST,
    hideLoader,
});

export const getActiveChargebackReportSuccess = payload => ({
    type: GET_ACTIVE_CHARGEBACK_REPORT_SUCCESS,
    payload,
});

export const getActiveChargebackReportError = payload => ({
    type: GET_ACTIVE_CHARGEBACK_REPORT_ERROR,
    payload,
});

export const resetFindTransactionForm = () => ({
    type: RESET_FIND_TRANSACTION_FORM,
});

export const resetRaiseChargebackForm = () => ({
    type: RESET_RAISE_CHARGEBACK_FORM,
});

// describe events and changes that need to occur in the application.
export const fetchRefundDisputeRequest = data => ({
    type: REFUND_DISPUTE_REQUEST,
    payload: data,

});
export const fetchRefundDisputeSuccess = data => ({
    type: REFUND_DISPUTE_SUCCESS,
    payload: data,
});
export const fetchRefundDisputeFailure = error => ({
    type: REFUND_DISPUTE_FAILURE,
    payload: error,
});
